
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react'
// import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import DataGridWrapper from '@/projects/syncflow/components/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import SelectBox, { SelectBoxTypes } from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';
import { DataGrid, DateBox, Popup } from 'devextreme-react';
import { preorderService } from '../services/preorder-service';
import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import { toast } from 'react-toastify';
import { confirm } from 'devextreme/ui/dialog';
import { Validator, RequiredRule } from 'devextreme-react/validator';
import { Chart, Series, Label, CommonSeriesSettings } from 'devextreme-react/chart';
import { vendorService } from '@/projects/syncflow/services/vendor_supply_parameter-service';
import { accountParameterService } from '@/projects/syncflow/services/account-paramater-service';
import { defaultGroupByFn } from 'react-table';
import { DateBoxTypes } from 'devextreme-react/cjs/date-box';

const Preorder = () => {
    let preOrderId: number;
    let vendorId: string;
    let categoryId: string;
    let productId: string;
    let cutoffId: string;

    const validatorRef = useRef(null);
    const dataGridRef = useRef<DataGrid>(null);
    const dataGridRefForDetail = useRef<DataGrid>(null);
    const dgVendorSummaryRef = useRef<DataGrid>(null);

    const [store, setStore] = useState<CustomStore>();
    const [storeVendorSummaries, setStoreVendorSummaries] = useState<CustomStore>();
    const [storeChartData, setChartData] = useState<CustomStore>();

    const [accountGmtValue, setGmtValue] = useState<number>(0);
    const getGmt = async () => {
        setGmtValue(await accountParameterService.getGmt())
    };
    useEffect(() => {
        getGmt();
    }, []);
    const [locationsLookups] = useState(new CustomStore({
        load: preorderService.getLocationsLookups,
        useDefaultSearch: true
    }));

    const [vendorsLookups, setVendors] = useState();
    const getVendorsLookups = async () => {
        setVendors(await preorderService.getVendorsLookups(preOrderId))
    };

    const [cutOffsLookups, setCutOff] = useState();
    const getCutOffLookups = async () => {
        setCutOff(await preorderService.getCutOffsLookups(preOrderId))
    };

    const [categoriesLookups, setCategories] = useState();
    const getcategoriesLookups = async () => {
        setCategories(await preorderService.getCategoriesLookups(preOrderId))
    };

    const [productsLookups, setProducts] = useState();
    const getProductsLookups = async () => {
        setProducts(await preorderService.getProductsLookups(preOrderId))
    };

    const [selectedLocationCode, setSelectedLocationCode] = useState<string>("");
    const [selectedVendorCode, setSelectedVendorCode] = useState<string>("");

    useEffect(() => {
        setStore(new CustomStore({
            key: ["id"],
            load: onGetProductData,
            update: preorderService.updatePreorder,
            useDefaultSearch: true
        }));
    }, [])

    useEffect(() => {
        setStoreVendorSummaries(new CustomStore({
            key: ["preOrderId", "vendorCode"],
            load: onGetVendorSummaries,
            useDefaultSearch: true
        }));
    }, [])

    useEffect(() => {
        setChartData(new CustomStore({
            key: ["ordersLinesId"],
            load: onGetChartData,
            useDefaultSearch: true
        }));
    }, [])


    const onLocationChanged = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        const selectedRow = e.component.option("selectedItem");
        const locationCode = selectedRow?.code;
        setSelectedLocationCode(locationCode);
        preOrderId = e.value;
        getVendorsLookups();
        // getCutOffLookups();
        getcategoriesLookups();
        getProductsLookups();
    }, []);

    const onVendorChanged = useCallback((e: SelectBoxTypes.ValueChangedEvent) => { vendorId = e.value; setSelectedVendorCode(e.value); }, []);
    const onCategoryChanged = useCallback((e: SelectBoxTypes.ValueChangedEvent) => { categoryId = e.value; }, []);
    const onProductChanged = useCallback((e: SelectBoxTypes.ValueChangedEvent) => { productId = e.value; }, []);
    const onCutOffChanged = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        // cutoffId = e.value; 
        var tval = e.value.getHours().toString().padStart(2, '0') + ':' + e.value.getMinutes().toString().padStart(2, '0');
        cutoffId = tval;
    }, []);


    const onGetProductData = useCallback(async () => {
        const x = await preorderService.getPreorder(preOrderId, vendorId, categoryId, productId, cutoffId, orderDayValue);
        return x;
    }, []);

    const onGetVendorSummaries = useCallback(async () => {
        const x = await preorderService.getVendorSummaries(preOrderId, vendorId, categoryId, productId, cutoffId);
        return x;
    }, []);


    const [popupVisible, setPopupVisible] = useState(false);
    const showInfo = useCallback((e: any) => {
        setPopupVisible(true);
    }, [setPopupVisible]);

    const hideInfo = useCallback(() => {
        setPopupVisible(false);
    }, [setPopupVisible]);

    const [isCutoffAfterOrder, setIsCutoffAfterOrder] = useState(false);

    useEffect(() => {
        var params = {
            locationcode: selectedLocationCode,
            vendorCode: selectedVendorCode
        };
        vendorService.getSupplierCutOffAfterOrder(params).then(setIsCutoffAfterOrder);
    }, [selectedLocationCode, selectedVendorCode]);

    console.log("cutof değer=" + isCutoffAfterOrder);

    let ordersLinesId = 1;
    const onGetChartData = useCallback(async () => {
        const x = await preorderService.getChartData(ordersLinesId);
        return x;
    }, []);

    const [isRowDetailPopupVisible, setIsRowDetailPopupVisible] = useState(false);


    const showRowDetail = useCallback((e: any) => {

        preorderService.getChartData(e).then(
            x => {
                setChartData(x);
                setIsRowDetailPopupVisible(true);
            }

        );
        //;
    }, [setIsRowDetailPopupVisible]);

    const hideRowDetail = useCallback(() => {
        setIsRowDetailPopupVisible(false);
    }, [setIsRowDetailPopupVisible]);


    const onQuery = useCallback(async () => {

        if (dataGridRef.current?.instance.hasEditData()) {
            let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
            result.then((dialogResult) => {
                if (dialogResult) {
                    dataGridRef.current?.instance.saveEditData().then(x => {
                        dataGridRef.current?.instance.refresh().then(x => dataGridRef.current?.instance.cancelEditData());
                    });
                }
                else {
                    dataGridRef.current?.instance.cancelEditData();
                    dataGridRef.current?.instance.refresh();
                }
            });
        }
        else {
            dataGridRef.current?.instance.refresh();
        }
    }, []);

    const onSave = async () => {
        if (dataGridRef.current?.instance.hasEditData()) {

            let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
            result.then((dialogResult) => {
                if (dialogResult) {
                    dataGridRef.current?.instance.saveEditData().then(x => {
                        dataGridRef.current?.instance.refresh().then(x => dataGridRef.current?.instance.cancelEditData());
                    });
                }
            });
        }
    }

    const onSaving = (e: DataGridTypes.SavingEvent) => {
        e.cancel = true;
        if (e.changes.length > 0) {
            preorderService.updatePreorderBatch(e.changes, selectedLocationCode).then((response) => {
                dataGridRef.current?.instance.refresh().then(x => dataGridRef.current?.instance.cancelEditData());
                toast.success(t("syncflow:msg_saved"));
            });
        }
    }

    const onClear = useCallback(async () => {
    }, []);

    const onShowVendorSummary = async () => {
        if (dataGridRef.current?.instance.getDataSource().totalCount() == 0)
            return;

        if (dataGridRef.current?.instance.hasEditData()) {

            let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
            result.then((dialogResult) => {
                if (dialogResult) {
                    dataGridRef.current?.instance.saveEditData()
                        .then(x => {
                            dataGridRef.current?.instance.refresh()
                                .then(x => {
                                    dataGridRef.current?.instance.cancelEditData();
                                    dgVendorSummaryRef.current?.instance.refresh().then(x => showInfo(0));
                                });
                        });
                }
                else {
                    dataGridRef.current?.instance.cancelEditData();
                    dataGridRef.current?.instance.refresh().then(x => dgVendorSummaryRef.current?.instance.refresh().then(x => showInfo(0)));
                }
            });
        }
        else {
            dgVendorSummaryRef.current?.instance.refresh().then(x => showInfo(0));
        }
    }

    const onEditingStart = (e: any) => {
        if (e.column.dataField == "approvedQty") {
            if (isCutoffAfterOrder) {
                const cutoff = e.data.cuttOff;

                let isPastCutoff = false;
                if (cutoff) {
                    isPastCutoff = accountParameterService.isPastCutoffTime(cutoff, accountGmtValue)
                }
                if (e.data.isVendorApproved || (!e.data.isOrderDay) || isPastCutoff) {
                    e.cancel = true;
                    if (isPastCutoff) { toast.error("Cut-off saati geçtiği için düzenleme yapılamaz!"); }
                }
            }
        }
    }

    const onCellPrepared = async (e: any) => {
        if (e.hasOwnProperty("data")) {
            if ((e.column.dataField === 'approvedQty') && !e.data.isVendorApproved) {
                e.cellElement.style.backgroundColor = '#E6F1FF';
            }
        }
    };

    const onFocusedCellChanging = (e: { isHighlighted: boolean; cellElement: string[] }) => {
        e.isHighlighted = true;
        if (typeof e.cellElement[0] === 'object') {
            const tdElement = e.cellElement[0] as unknown as HTMLElement;
            console.log(tdElement.innerHTML);
            const value = parseInt(tdElement.innerHTML);

            if (!isNaN(value) && value < 0) {
                tdElement.innerHTML = "0";
            }
        } else {
            console.error("e.cellElement[0] is not an HTMLElement.");
        }
    };

    const orderDaysLookup = [
        { id: 1, name: t("syncflow:op_yes") },
        {
            id: 0, name: t("syncflow:op_no")
        }];

    let [orderDayValue, setValue] = useState(orderDaysLookup[0].id);
    const onOrderDaysChanged = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        setValue(e.value);
        orderDayValue = e.value;
    }, []);

    const [selectedRowKeys, setSelectedRowKeys] = useState<any | null>(null);

    const onSelectionChanged = (args: DataGridTypes.SelectionChangedEvent) => {
        if (isCutoffAfterOrder) {
            const pastCutoffs: any[] = [];
            const validSelection = args.selectedRowsData.filter((row: any) => {
                if (isCutoffAfterOrder) {
                    if (!row.cutOff) return false;
                    const isPastCutoff = accountParameterService.isPastCutoffTime(row.cutOff, accountGmtValue)
                    if (isPastCutoff) {
                        pastCutoffs.push(row);
                        return false;
                    }
                    console.log(
                        "cutOff:", row.cutOff,
                        "accountGmtValue:", accountGmtValue,
                        "isPastCutoff:", isPastCutoff
                    );
                    return true;
                }
                return true;
            });

            const validKeys = validSelection.map((row: any) => row.vendorCode);

            setSelectedRowKeys(validKeys);
            args.component.selectRows(validKeys, false);

            if (pastCutoffs.length > 0) {
                toast.warning(t("syncflow:msg_cutoff_selection_warning") || "Cut-off saati geçmiş satırlar seçilemez!");
            }
        }
        else {
            setSelectedRowKeys(args.selectedRowKeys);
        }
    };

    const approveFunc = () => {
        if (selectedRowKeys.length > 0) {
            let result = confirm(t("syncflow:msg_approve_confirm"), t("syncflow:ti_confirm"));
            result.then((dialogResult) => {
                if (dialogResult) {
                    selectedRowKeys.forEach((e: any) => {
                        preorderService.venderApproveFunc(e.preOrderId, selectedVendorCode, selectedLocationCode).then((response) => {
                            dgVendorSummaryRef.current?.instance.refresh();
                            setPopupVisible(false);
                            dataGridRef.current?.instance.refresh();
                            toast.success(t("syncflow:msg_saved"));
                        })
                    });
                }
            });
        }
    }
    const renderGridCell = (data: any) => (data.price * data.approvedQty);
    return (
        <>
            <div className='row mb-4 justify-content-end'>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_list")}
                        type="default"
                        icon="refresh"
                        onClick={onQuery}
                    />
                </div>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_clear")}
                        type="default"
                        icon="clearformat"
                        onClick={onClear}
                    />
                </div>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_save")}
                        type="default"
                        icon="save"
                        onClick={onSave}
                    />
                </div>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_summary")}
                        type="default"
                        icon="showpanel"
                        onClick={onShowVendorSummary}
                    />
                </div>
            </div>

            <div className="row mb-12">
                <label className="col-lg-1 col-form-label required fw-bold fs-6"> {t("syncflow:location")}</label>
                <div className="col-lg-3">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="locationsLookups"
                                dataSource={locationsLookups}
                                key="code"
                                valueExpr="id"
                                displayExpr="name"
                                onValueChanged={onLocationChanged}
                                showClearButton={true}>
                                <Validator ref={validatorRef}>
                                    <RequiredRule message="Confirm Store is required" />
                                </Validator>
                            </SelectBox>
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lu_vendor")}</label>
                <div className="col-lg-3">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="vendorsLookups"
                                dataSource={vendorsLookups}
                                valueExpr="id"
                                displayExpr="name"
                                searchEnabled={true}
                                onValueChanged={onVendorChanged}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lu_cut_off")}</label>
                <div className="col-lg-3">
                    <div className="row">
                        <div className="fv-row">
                            {/* <SelectBox
                                name="cutOffsLookups"
                                dataSource={cutOffsLookups}
                                valueExpr="id"
                                displayExpr="name"
                                onValueChanged={onCutOffChanged}
                                showClearButton={true} /> */}

                            <DateBox type="time" showClearButton={true} onValueChanged={onCutOffChanged} />

                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lu_category")}</label>
                <div className="col-lg-3">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="categoriesLookups"
                                dataSource={categoriesLookups}
                                valueExpr="id"
                                displayExpr="name"
                                searchEnabled={true}
                                onValueChanged={onCategoryChanged}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lu_product")}</label>
                <div className="col-lg-3">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="productsLookups"
                                dataSource={productsLookups}
                                valueExpr="id"
                                displayExpr="name"
                                searchEnabled={true}
                                onValueChanged={onProductChanged}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lu_is_order_day")}</label>
                <div className="col-lg-3">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="orderDaysLookup"
                                items={orderDaysLookup}
                                valueExpr="id"
                                displayExpr="name"
                                onValueChanged={onOrderDaysChanged}
                                value={orderDayValue}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
            </div>
            <Popup
                visible={popupVisible}
                onHiding={hideInfo}
                title={t("syncflow:ti_aprrovement_by_vendor")}
                showTitle={true}
                width={1200}
                height={740}
                position={{ of: window, at: 'center', my: 'center' }}
            >
                <div className='row mb-4 justify-content-end'>
                    <div className='col-auto'>
                        <Button
                            text={t("syncflow:btn_approve")}
                            type="default"
                            stylingMode="contained"
                            icon="check"
                            onClick={approveFunc}
                        />
                    </div>
                </div>
                <DataGridWrapper
                    props={{ ref: dgVendorSummaryRef }}
                    datasource={storeVendorSummaries}
                    showColumnLines={true}
                    onSelectionChanged={onSelectionChanged}
                    remoteOperations={false}
                    columnChooser={false}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    selectionConfig={{ mode: 'multiple', selectAllMode: 'allPages', showCheckBoxesMode: 'always' }}
                    editingConfig={{
                        mode: "batch",
                        allowDeleting: false,
                        allowUpdating: true,
                    }}
                    columns={[
                        {
                            dataField: 'vendorName',
                            caption: t('syncflow:lb_vendor'),
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'cutOff',
                            caption: t('syncflow:lb_cutoff'),
                            allowFiltering: false,
                            allowEditing: false,
                            dataType: "datetime",
                            format: "hh:mm a",
                            // cellRender: (data: any) => {
                            //     // if (isCutoffAfterOrder) {
                            //     // const cutoff = data.data.cutOff;
                            //     // const isPastCutoff = accountParameterService.isPastCutoffTime(cutoff, accountGmtValue)
                            //     // return (
                            //     //     <span style={{ color: isPastCutoff && isCutoffAfterOrder ? 'red' : 'inherit' }}>
                            //     //         {cutoff}
                            //     //     </span>
                            //     // );
                            //     // }
                            // }
                        },
                        {
                            dataField: 'productCount',
                            caption: t('syncflow:lb_product_count'),
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'qty',
                            caption: t('syncflow:lb_order_quantity'),
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'amount',
                            caption: t('syncflow:lb_order_amount'),
                            allowFiltering: false,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        }
                    ]}
                />
            </Popup>
            <Popup
                visible={isRowDetailPopupVisible}
                onHiding={hideRowDetail}
                title={t('syncflow:ti_sale_details')}
                showTitle={true}
                width={800}
                position={{
                    of: window,
                    at: 'center',
                    my: 'center'
                }} >
                <Chart id="chart"
                    title=""
                    dataSource={storeChartData}>
                    <CommonSeriesSettings type="bar" argumentField="day">
                        <Label visible></Label>
                    </CommonSeriesSettings>
                    <Series
                        name={t("syncflow:lb_last_week_revenue")}
                        valueField="lastWeekRevenue"
                        color="rgba(58, 179, 255, 0.7)" />
                    <Series
                        name={t("syncflow:lb_two_week_revenue")}
                        valueField="lastTwoWeekRevenue"
                        color="rgb(209, 129, 255, 0.7)" />
                </Chart>
                <br></br>
                <React.Fragment>
                    <DataGridWrapper
                        props={{ ref: dataGridRefForDetail }}
                        datasource={storeChartData}
                        remoteOperations={false}
                        columnChooser={false}
                        showColumnLines={true}
                        pagerVisible={false}
                        filterVisible={false}
                        headerFilterVisible={false}
                        keyboardNavigation={false}
                        editingConfig={{
                            mode: "batch",
                            useIcons: true,
                            allowAdding: false,
                            allowDeleting: false,
                            allowUpdating: false
                        }}
                        columns={[
                            {
                                dataField: 'day',
                                caption: t("syncflow:lb_day"),
                                allowFiltering: true,
                                allowEditing: false,
                            },
                            {
                                dataField: 'lastWeekRevenue',
                                caption: t("syncflow:lb_last_week_revenue"),
                                allowFiltering: true,
                                allowEditing: false,
                                format: { numberFormat }
                            },
                            {
                                dataField: 'lastTwoWeekRevenue',
                                caption: t("syncflow:lb_two_week_revenue"),
                                allowFiltering: true,
                                allowEditing: false,
                                format: { numberFormat }
                            },
                            {
                                dataField: 'lastWeekSaleCount',
                                caption: t("syncflow:lb_last_week_count"),
                                allowFiltering: true,
                                allowEditing: false,
                                format: { numberFormat }
                            },
                            {
                                dataField: 'lastTwoWeekSaleCount',
                                caption: t("syncflow:lb_last_two_week_count"),
                                allowFiltering: true,
                                allowEditing: false,
                                format: { numberFormat }
                            }
                        ]}
                    />
                </React.Fragment>
            </Popup>
            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    remoteOperations={false}
                    showColumnLines={true}
                    columnChooser={true}
                    onEditingStart={onEditingStart}
                    onSaving={onSaving}
                    onCellPrepared={onCellPrepared}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: true,
                        updateMessageText: RemoveMessage('Resource'),
                        onCellValueChanged: (e: any) => {
                            if (e.value < 0) {
                                e.value = 0;
                            }
                        },
                    }}
                    columns={[
                        {
                            dataField: 'productCode',
                            caption: t('syncflow:lb_product_code'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'productName',
                            caption: t('syncflow:lb_product_name'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'productBarcode',
                            caption: t('syncflow:lb_product_barcode'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'vendorName',
                            caption: t('syncflow:lb_vendor'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'unit',
                            caption: t('syncflow:lb_measurement_unit_code'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'approvedQty',
                            caption: t('syncflow:lb_approved_order_quantity'),
                            allowFiltering: true,

                        },
                        {
                            dataField: 'initialQty',
                            caption: t('syncflow:lb_recomended_order_quantity'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'forecastQty',
                            caption: t('syncflow:lb_forecast'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'price',
                            caption: t('syncflow:lb_product_price'),
                            allowFiltering: true,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true },
                        },
                        {
                            dataField: 'approvedAmount',
                            caption: t('syncflow:lb_order_amount'),
                            allowFiltering: true,
                            allowEditing: false,
                            calculateCellValue: renderGridCell,
                            format: { style: "currency", currency: "USD", useGrouping: true },
                        },
                        {
                            dataField: 'cuttOff',
                            caption: t('syncflow:lu_cut_off'),
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: "time",
                            format: "hh:mm a",
                            // cellRender: (data: any) => {
                            //     const cutoff = data.data.cuttOff;

                            //     const isPastCutoff = accountParameterService.isPastCutoffTime(cutoff, accountGmtValue)
                            //     return (
                            //         <span style={{ color: isPastCutoff && isCutoffAfterOrder ? 'red' : 'inherit' }}>
                            //             {cutoff}
                            //         </span>
                            //     );
                            // }
                        },
                        {
                            caption: t('syncflow:lb_detail'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                return (
                                    <Button
                                        text={t("syncflow:btn_detail")}
                                        type="default"
                                        icon='showpanel'
                                        stylingMode="contained"
                                        onClick={() => showRowDetail(data.data.id)}
                                    />
                                );
                            },
                        }
                    ]}
                />
            </React.Fragment>
        </>
    )
}
const numberFormat = {
    type: 'fixedPoint',
    precision: 1,
};
export default Preorder